module.exports = __webpack_public_path__ + "img/warn.18e84ff1.svg";